import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, EMPTY, filter, map, of, switchMap } from 'rxjs';

import { PLAccountsSuccess } from '@app/common/store';
import { Injectable } from '@angular/core';
import { FeatureFlagService } from '@app/common/services/feature-flag.service';
import { concatLatestFrom } from '@ngrx/operators';
import { FeatureFlags } from '@app/common/constant';
import { Store } from '@ngrx/store';
import { selectCurrentUserId } from 'pl-core-services';

import * as actions from '../current/current.actions';
import { SubscriptionApiService } from '../../services';

@Injectable()
export class LoadCurrentSubscriptionEffects {
  loadCurrentSubscription$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PLAccountsSuccess),
      filter(({ account }) => account?.type === 'individual'),
      concatLatestFrom(() => this.store.select(selectCurrentUserId)),
      switchMap(([{ account }, userId]) =>
        this.featureFlagService
          .isFeatureEnabled(FeatureFlags.SUBSCRIPTION_MANAGEMENT)
          .pipe(
            switchMap((isSubscriptionEnabled) => {
              if (!isSubscriptionEnabled) {
                return EMPTY;
              }

              return this.subscriptionService
                .getSubscription(account.uuid, userId)
                .pipe(
                  map((subscription) =>
                    actions.loadCurrentSubscriptionSuccess({ subscription })
                  ),
                  catchError((error) =>
                    of(actions.loadCurrentSubscriptionError({ error }))
                  )
                );
            })
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private subscriptionService: SubscriptionApiService,
    private featureFlagService: FeatureFlagService
  ) {}
}
